export default __webpack_public_path__ + "static/media/logo.c38a9163.svg";